import { isNullOrUndefined } from "/Assets/js/utilities.js";

document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById("global-landing-page")) {
        const globalLandingPage = new GlobalLandingPage();
        globalLandingPage.init();
    }
});

export default class GlobalLandingPage {
    init() {
        // Reset cached navigation items in local storage
        const mainNavigationCacheKey = "hypertherm-main-nav";
        const productFinderCacheKey = "hypertherm-product-finder";

        localStorage.removeItem(mainNavigationCacheKey);
        localStorage.removeItem(productFinderCacheKey);

        this.setUrlAnchor();
    }

    setUrlAnchor() {
        var url = window.location;
        var anchor = url.hash;

        if (isNullOrUndefined(anchor))
            return;

        var inputs = document.querySelectorAll("input[name=urlanchor]");

        if (!inputs.length)
            return;

        [...inputs].forEach(input => {
            input.value = anchor;
        });
    }
}
